<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body>

    <el-form :model="form" :rules="rules" hide-required-asterisk ref="form"  label-position="left">

        <el-form-item prop="appId">
          <template v-slot:label>
            <div class="form-item__label">所属应用</div>
          </template>
          <search-channel-app-select v-model="form.appId" :disabled="title" @change-item="getSlotName1" style="width: 100%;" />
        </el-form-item>
        <el-form-item prop="slotTypeId">
          <template v-slot:label>
            <div class="form-item__label">广告位类型</div>
          </template>
           <search-slot-type-select v-model="form.slotTypeId" @change-item="getSlotName2" style="width: 100%" />
        </el-form-item>
        <el-form-item prop="slotName">
          <template v-slot:label>
            <div class="form-item__label">广告位名称</div>
          </template>
          <el-input v-model="form.slotName"  placeholder="请输入名称" :disabled="isName" />
          <el-button @click="isName=false">自定义名称</el-button>
        </el-form-item>
        <el-form-item prop="sizeId">
          <template v-slot:label>
            <div class="form-item__label">广告位尺寸</div>
          </template>
          <div style="width: 100%; display: inline-block;">
            <el-select v-model="form.sizeId" placeholder="请选择广告位尺寸" @change="change" :style="form.sizeId == 0 ? 'width: 46%;' : 'width: 100%;'">
              <el-option
                v-for="item in slotSizeList"
                :label="item.slotSize"
                :value="item.sizeId"
                :key="item.sizeId" />
            </el-select>
            <el-input v-show="form.sizeId==0" v-model="form.customizeSize"  placeholder="请输入您的广告位尺寸" style="margin-left:2%;width: 52%;"/>
          </div>
        </el-form-item>
        <el-form-item prop="slotPv">
          <template v-slot:label>
            <div class="form-item__label">访问量(PV)</div>
          </template>
          <el-input v-model="form.slotPv"  placeholder="请输入访问量" />
        </el-form-item>
        <el-form-item label-width="110px">
          <template v-slot:label>
            <div>计费方式：</div>
          </template>
          <el-radio
            v-for="item in billingTypeList"
            v-model="form.billingType"
            :label="item.value"
            :key="item.value">{{ item.label }}</el-radio>
        </el-form-item>
        <el-form-item label-width="110px">
          <template v-slot:label>
            <div>结算方式：</div>
          </template>
          <el-radio
            v-for="item in settlementTypeList"
            v-model="form.settlementType"
            :label="item.value"
            :key="item.value">{{ item.label }}</el-radio>
        </el-form-item>
        <el-form-item :prop="form.settlementType==0?lowPrice:'lowprice2'" v-show="form.settlementType==0">
          <template v-slot:label >
            <div class="form-item__label">广告底价（单位：分）<span style="color:red">{{form.lowPrice/100}}<span style="margin-left:5px">ecpm</span></span></div>
          </template>
          <el-input v-model="form.lowPrice" type="number"  placeholder="" />
        </el-form-item>
        <el-form-item label-width="110px">
          <template v-slot:label>
            <div>支持DP上报：</div>
          </template>
          <el-radio v-model="form.isDp" :label="0">是</el-radio>
          <el-radio v-model="form.isDp" :label="1">否</el-radio>
        </el-form-item>
        <el-form-item label-width="110px">
          <template v-slot:label>
            <div>支持直接下载：</div>
          </template>
          <el-radio v-model="form.isDownload" :label="0">是</el-radio>
          <el-radio v-model="form.isDownload" :label="1">否</el-radio>
        </el-form-item>
        <el-form-item prop="budget">
          <template v-slot:label>
            <div class="form-item__label">想跑的预算：</div>
          </template>
          <el-checkbox-group v-model="form.budget" style="width: 100%; display: inline-block;">
            <el-checkbox v-for="item in budgetList" :label="item.budgetId" :key="item.budgetId">{{ item.budgetName }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item prop="imageUrl">
          <template v-slot:label>
            <div class="form-item__label">广告位截图：</div>
          </template>
          <div style="width: 100%; display: inline-block;">
            <el-upload
              class="avatar-uploader"
              :action="$baseURL + 'common/upload/image'"
              :headers="header"
              :show-file-list="false"
              :on-success="onSuccess"
              accept="image/*">
              <img v-if="form.imageUrl" :src="$imgURL + form.imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>

      </el-form>

    <div style="text-align: right;">
      <el-button @click="close" >取消</el-button>
      <el-button @click="submit" type="primary"  :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

import SearchSlotTypeSelect from '@/components/SearchSlotTypeSelect'
import SearchChannelAppSelect from '@/components/SearchChannelAppSelect'
import {hot} from "@/api/hot"
import { getSlotSize, getSlotBudget } from '@/api/select'
import { addSlot, updateSlot } from '@/api/media/app/ad'
import { appTypeList } from '@/const/app-type'
import { billingTypeList } from '@/const/billing-type'
import { settlementTypeList } from '@/const/settlement-type'

const form = {
  appId: undefined,
  slotName: "",
  slotTypeId: undefined,
  sizeId: undefined,
  customizeSize: undefined,
  slotPv: undefined,
  billingType: 0,
  settlementType: 0,
  lowPrice: 0,
  isDp: 0,
  isDownload: 0,
  budget: [],
  imageUrl: undefined
}
export default {
  props: {
    width: {
      type: Number,
      default: 600
    },
    data: Object
  },
  emits: ['submit'],
  components: {
    SearchSlotTypeSelect,
    SearchChannelAppSelect
  },
  data () {
    return {
      dialogStatus: false,
      submitLoading: false,
      header: {},
      form: Object.assign({}, form),
      rules: {
        appId: [{ required: true, message: '请选择所属应用', trigger: 'change' }],
        slotName: [{ required: true, message: '请输入广告位名称', trigger: 'blur' }],
        slotTypeId: [{ required: true, message: '请选择广告位类型', trigger: 'change' }],
        sizeId: [{ required: true, message: '请选择广告位尺寸', trigger: 'change' }],
        slotPv: [{ required: true, message: '请输入访问量(PV)', trigger: 'blur' }],
        lowPrice: [{ required: true, message: '请输入广告底价', trigger: 'blur' }],
        lowprice2: [{ required: false, message: '请输入广告底价', trigger: 'blur' }]
      },
      appTypeList,
      billingTypeList,
      settlementTypeList,
      slotSizeList: [],
      budgetList: [],
      title: false,
      isName: true,
      reSlotName:undefined
    }
  },
  created () {
    this.header = {
      Authorization: 'Bearer ' + this.access_token
    }
    this.getSlotSize()
    this.getSlotBudget()
  },
  computed: {
    ...mapGetters([
      'access_token'
    ]),
    dialogTitle () {
      return (this.title ? '编辑' : '新增') + '广告位'
    }
  },
  methods: {
    init () {},
    getSlotSize () {
      getSlotSize().then(res => {
        if (res.code === 200) {
          this.slotSizeList = res.data
          this.slotSizeList.unshift({ sizeId: 0, slotSize: '其它' })
        }
      })
    },
    getSlotBudget () {
      getSlotBudget().then(res => {
        if (res.code === 200) {
          this.budgetList = res.data
        }
      })
    },
    show (data) {
      this.dialogStatus = true
      if (data) {
        this.form = Object.assign({}, data)
        if(!this.form.sizeId){
          this.form.sizeId=0
        }
        if (this.form.budgetNameIdList) {
          this.form.budget = this.form.budgetNameIdList.map(item => {
            return item.budgetId
          })
        } else {
          this.form.budget = []
        }
        this.title = true
      }else{
        this.form.slotName=""
      }
    },
    close () {
      this.dialogStatus = false
      this.title = false
      this.reset()
    },
    onSuccess (res) {
      if (res.code === 200) {
        this.form.imageUrl = res.data[0] || ''
      }
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid && this.validate()) {
          if(this.form.settlementType!==0){
            this.form.lowPrice=0
          }
          if (this.title) {
            this.update(this.normalForm())
          } else {
            this.add(this.normalForm())
          }
        }
      })
    },
    validate () {
      if (this.form.sizeId !== 0) {
        this.form.customizeSize = undefined
      }
      return true
    },
    normalForm () {
      const form = JSON.parse(JSON.stringify(this.form))
      form.budget = form.budget.join(',') || ''
      return form
    },
    add (form) {
      this.submitLoading = true
      addSlot(form).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    update (form) {
      this.submitLoading = true
      updateSlot(form).then(res => {
        if (res.code === 200) {
          this.$message.success('编辑成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    reset () {
      this.form = {
          appId: undefined,
          slotName: undefined,
          slotTypeId: undefined,
          sizeId: undefined,
          customizeSize: undefined,
          slotPv: undefined,
          billingType: 0,
          settlementType: 0,
          lowPrice: 0,
          isDp: 0,
          isDownload: 0,
          budget: [],
          imageUrl: undefined
        }
    },
    getSlotName1 (item) {
      this.reSlotName=item.appName
    },
    getSlotName2 (item) {
      this.form.slotName = this.reSlotName + '_' + item.label
    },
    change(item){
      let data={
        maker:"slotSizeOnThe",
        onTheOrderId:item
      }
      if(item){
        hot(data)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-label{
  display: block;
  line-height: 20px;
}

.form-item__label{
  line-height: 20px;
}

::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
::v-deep .el-upload:hover {
  border-color:red;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
.avatar {
  width: 200px;
  height: 120px;
  display: block;
}
</style>
